import { Dispatch } from 'react-redux';
import { Action } from 'redux';

import { GetUserNotificationSettings, GetUserNotificationSettingsFailed, GetUserNotificationSettingsSucceeded, UpdateUserNotificationSettings, UpdateUserNotificationSettingsFailed, UpdateUserNotificationSettingsSucceeded } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { AppState } from '../../app/state/AppState';
import { IUserNotificationSetting, IUserNotificationSettingsInfo } from '../models/IUserNotificationsSettingsInfo';
import { UserNotificationSettingsLayer } from '../models/UserNotificationSettingsLayer';

export interface IUserNotificationSettingsActionContext {
  layer: UserNotificationSettingsLayer;
  siteId?: string;
}

export interface IUpdateUserNotificationSettingsActionParams extends IUserNotificationSettingsActionContext {
  updatedSettings: IUserNotificationSetting[];
}

export class UserNotificationSettingsActions {

  constructor(readonly dispatch: Dispatch<AppState>) { }

  public getSettings(params: IUserNotificationSettingsActionContext) {
    this.dispatch(getUserNotificationSettingsAction(params));
  }

  public updateSettings(params: IUpdateUserNotificationSettingsActionParams) {
    this.dispatch(updateUserNotificationSettingsAction(params));
  }
}

export interface GetUserNotificationSettingsAction extends Action, IUserNotificationSettingsActionContext {
}

export interface GetUserNotificationSettingsSucceededAction extends Action {
  settings: IUserNotificationSettingsInfo;
}

export interface GetUserNotificationSettingsFailedAction extends Action { }

export interface UpdateUserNotificationSettingsAction extends Action, IUpdateUserNotificationSettingsActionParams {
}

export interface UpdateUserNotificationSettingsSucceededAction extends Action {
  updatedSettings: IUserNotificationSetting[];
}

export interface UpdateUserNotificationSettingsFailedAction extends Action { }

export const {
  factory: getUserNotificationSettingsAction,
  isAction: isGetUserNotificationSettingsAction
} = parameteredActionHelpers<GetUserNotificationSettingsAction>(GetUserNotificationSettings);

export const {
  factory: getUserNotificationSettingsSucceededAction,
  isAction: isGetUserNotificationSettingsSucceededAction
} = parameteredActionHelpers<GetUserNotificationSettingsSucceededAction>(GetUserNotificationSettingsSucceeded);

export const {
  factory: getUserNotificationSettingsFailedAction,
  isAction: isGetUserNotificationSettingsFailedAction
} = simpleActionHelpers<GetUserNotificationSettingsFailedAction>(GetUserNotificationSettingsFailed);

export const {
  factory: updateUserNotificationSettingsAction,
  isAction: isUpdateUserNotificationSettingsAction
} = parameteredActionHelpers<UpdateUserNotificationSettingsAction>(UpdateUserNotificationSettings);

export const {
  factory: updateUserNotificationSettingsSucceededAction,
  isAction: isUpdateUserNotificationSettingsSucceededAction
} = parameteredActionHelpers<UpdateUserNotificationSettingsSucceededAction>(UpdateUserNotificationSettingsSucceeded);

export const {
  factory: updateUserNotificationSettingsFailedAction,
  isAction: isUpdateUserNotificationSettingsFailedAction
} = simpleActionHelpers<UpdateUserNotificationSettingsFailedAction>(UpdateUserNotificationSettingsFailed);


/** Creates the factory function and the isXAction function for an action with no params */
function simpleActionHelpers<T extends Action>(name: string) {
  return {
    factory: simpleAction<T>(name),
    isAction: isActionFactory<T>(name)
  };
}

/** Creates the factory function and the isXAction function for an action with params */
function parameteredActionHelpers<T extends Action>(name: string) {
  return {
    factory: parameteredAction<T>(name),
    isAction: isActionFactory<T>(name)
  };
}

function parameteredAction<T extends Action>(name: string) {
  return (params: Omit<T, 'type'>) => ({ type: name, ...params });
}

function simpleAction<T extends Action>(name: string): (() => T) {
  return () => ({ type: name } as T);
}